module.exports = __webpack_public_path__ + "img/6_58.db6c8fba.png";